import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

export default [
  {
    component: LazyComponent(lazy(() => import('./Create'))),
    path: '/pipeline/create',
  },
  {
    component: LazyComponent(lazy(() => import('./Update'))),
    path: '/pipeline/update/:id',
  },
];
